import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  BlogCarousel,
  CalendarPanel,
  WeatherPanel,
  CamPanel,
  AnimalInfoPanel,
  PartnerInfoPanel,
  FactsCarousel,
} from '../../components';
import makeCollapsible from '../../hocs/makeCollapsible';
import './styles.scss';

const propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.object,
};

const defaultProps = {
  type: '',
  title: '',
  body: {},
};

class InfoPanelView extends React.Component {

  constructor(props) {
    super(props);
    this.components = {
      cam: {
        component: CamPanel,
        title: 'Information',
        name: 'information',
      },
      partner: {
        component: PartnerInfoPanel,
        title: 'Partner',
        name: 'partner',
        innerClass: 'p-30',
      },
      animal: {
        component: AnimalInfoPanel,
        title: 'Q & A',
        name: 'qa',
        innerClass: 'p-30',
      },
      blog: {
        component: BlogCarousel,
        title: 'Blog',
        name: 'blog',
      },
      calendar: {
        component: CalendarPanel,
        title: 'Calendar',
        name: 'calendar',
      },
      weather: {
        component: WeatherPanel,
        title: 'Weather',
        name: 'weather',
        innerClass: 'p-20',
      },
      facts: {
        component: FactsCarousel,
        title: 'Factoids',
        name: 'facts',
      },
    };
  }

  shouldComponentUpdate(nextProps) {
    return this.props.currentItem.id !== nextProps.currentItem.id;
  }

  render() {
    const { type: infoType, currentItem } = this.props;
    let { loading } = this.props;
    let Panel;

    if (infoType in this.components) {
      const { component, title, name, innerClass } = this.components[infoType];
      // @todo: the defaultState provides a `currentItem` that is an empty map. I'm using
      // the `cam_group.id` to act as a determination as to whether the `currentItem` is actually
      // populated or not. This should be cleaned up.
      loading = !!(loading || _.isNil(_.get(currentItem, 'cam_group.id')));
      Panel = makeCollapsible(component, {
        title,
        name,
        innerClass,
        currentItem,
        loading,
      });
    }

    return (
      <div className={infoType !== 'animal' ? 'bg-fff-60 container-rounded mb-10' : 'bg-fff-60 container-rounded'}>
        {infoType in this.components ? <Panel /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { feedFetching } = state.cam_groups;
  return {
    currentItem: state.currentItem.data,
    loading: feedFetching && state.currentItem.isFetching,
    body: Object.assign({}, ownProps.body, { feedFetching }),
  };
};

InfoPanelView.propTypes = propTypes;
InfoPanelView.defaultProps = defaultProps;

export default connect(mapStateToProps)(InfoPanelView);
